<template>
  <v-container
    id="agentGroups"
    fluid
    class="page-container">
    <v-row>
      <v-col>

        <AgentGroupList></AgentGroupList>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';
  import AgentGroupList from '@/components/AgentGroups/AgentGroupList';

  export default {
    name: 'AgentGroups',
    extends: DataComponentBase,
    components: {
      AgentGroupList,
    },

    data () {
      return {
      }
    },

    computed: {
    },

    methods: {
    },

  };
</script>
